/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scan_Top_RightInputs */

const en_mobile_scan_top_right = /** @type {(inputs: Mobile_Scan_Top_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top right corner`)
};

const es_mobile_scan_top_right = /** @type {(inputs: Mobile_Scan_Top_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esquina superior derecha`)
};

/**
* | output |
* | --- |
* | "Top right corner" |
*
* @param {Mobile_Scan_Top_RightInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_scan_top_right = /** @type {((inputs?: Mobile_Scan_Top_RightInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scan_Top_RightInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_scan_top_right(inputs)
	return en_mobile_scan_top_right(inputs)
});